<MenuItem iconF7="list_bullet_indent" iconOnly {iconSize} dropdown on:menuOpened={buildDropdown}>
  <MenuDropdown left>
    <div class="cards-editor-layer-selector">
      <Treeview>
        <CardsEditorLayerTree layer={rootLayer} />
      </Treeview>
    </div>
  </MenuDropdown>
</MenuItem>

<style>
  *, *::before, *::after {
    box-sizing: border-box;
  }

  .cards-editor-layer-selector {
    white-space: nowrap;

    --f7-treeview-item-padding-left: 8px;
    --f7-treeview-item-padding-right: 16px;
    --f7-treeview-toggle-size: 20px;
    --f7-treeview-children-offset: 16px;
    /*
    --f7-treeview-label-font-weight: 400;
    --f7-treeview-label-text-color: inherit;
    */
  }</style>

<script lang="ts">import { MenuItem, MenuDropdown, Treeview } from 'framework7-svelte';
import './CardsEditorComponentInterfaces';
import CardsEditorLayerTree from './CardsEditorLayerTree.svelte';
import { CardsPageContextKey } from './context';
import { getContext } from 'svelte';
export let iconSize = 20;
const pageContext = getContext(CardsPageContextKey);
let rootLayer = null;
function buildDropdown() {
    rootLayer = pageContext.editorModeManager.getRootComponentLayer();
}
</script>